import React from "react";
import { KDialog } from "@kyburz/kdesign-system";
import ReactJson from "react-json-view";

interface Props {
  deviceImei: string;
  content: string;
  open: boolean;
  togglePopup: (imei: string, content: string) => void;
}

const CurrentDataPopup = ({ deviceImei, content, open, togglePopup }: Props) => {
  const closePopup = () => {
    togglePopup("", "");
  };

  const close = () => {
    closePopup();
  };

  return (
    <KDialog
      size="xs"
      title={`Current Data of ${deviceImei}`}
      open={open}
      primaryCTAonClick={close}
      primaryCTAText="Close"
      hasOverflow
    >
      <ReactJson src={content ? JSON.parse(content) : {}} />
    </KDialog>
  );
};

export default CurrentDataPopup;
